import { Dialog } from 'primereact/dialog';
import { useEffect } from 'react';
import { Button } from 'primereact/button';
import { useState } from 'react';
import ContactoAgregarDialog from './ContactoAgregarDialog';
import ContactoEditarDialog from './ContactoEditarDialog';
import { getContactosCliente } from '../../service/AffariService';

const ContactoDialog = ({ visible, onHide, data, onContactosChange }) => {

    const [visibleContactoAgregarDialog, setVisibleContactoAgregarDialog] = useState(false);
    const [visibleContactoEditarDialog, setVisibleContactoEditarDialog] = useState(false);
    const [contactos, setContactos] = useState([]);

    useEffect(() => {
        if (visible) {
            fetchContactos();
        }
    }, [visible]);

    const fetchContactos = () => {
        if (data?.cliente?.codigo) {
            getContactosCliente(data?.cliente?.codigo).then((response) => {
                const lista = Array.isArray(response) ? response : response?.contactos;
                const contactosActualizados = lista ?? [];
                setContactos(contactosActualizados);
                onContactosChange?.(contactosActualizados);
            });
        }
    };

    const handleAgregar = (e) => {
        e.preventDefault();
        setVisibleContactoAgregarDialog(true);
    };

    const handleEditar = (contacto) => {
        setVisibleContactoEditarDialog(true);
    };

    const handleCancelar = () => {
        onHide();
    };



    return (
        <>
            <Dialog 
                header="Contactos" 
                visible={visible} 
                className="p-fluid custom-dialog"
                onHide={onHide}
                footer={
                    <div className="flex justify-content-end">
                        <Button label="Cancelar" icon="pi pi-times" onClick={handleCancelar} />
                    </div>
                }
            >
                <div className="flex justify-content-end mb-3">
                    <Button label="Agregar" icon="pi pi-plus" className="p-button-sm" onClick={handleAgregar} />
                </div>

                <div className="flex flex-column gap-2">
                    {contactos?.length ? (
                        contactos.map((contacto) => (
                            <div key={contacto.id ?? `${contacto.nombre}-${contacto.email}`} className="flex align-items-center justify-content-between p-3 border-1 surface-border border-round">
                                <div className="flex flex-column gap-1">
                                    <span className="text-900 font-medium">{contacto.nombre}</span>
                                    <span className="text-600 text-sm">{contacto.email}</span>
                                </div>
                                <Button icon="pi pi-pencil" className="p-button-rounded p-button-text p-button-plain p-button-sm" onClick={() => handleEditar(contacto)} />
                            </div>
                        ))
                    ) : (
                        <span className="text-600 text-sm">No hay contactos.</span>
                    )}
                </div>
            </Dialog>

            <ContactoAgregarDialog visible={visibleContactoAgregarDialog} onHide={setVisibleContactoAgregarDialog} data={data} fetchContactos={fetchContactos} />
            <ContactoEditarDialog visible={visibleContactoEditarDialog} onHide={setVisibleContactoEditarDialog} data={data} fetchContactos={fetchContactos} />
        </>
    );
};

export default ContactoDialog;
